(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-faq"] && !Shopify.designMode) return;
  try {
    
  class RvFaqList extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.rv-faq__question').forEach(btn => {
        btn.addEventListener('click', () => {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          const answer = document.getElementById(btn.getAttribute('aria-controls'));
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          answer.hidden = expanded;
        });
      });
    }
  }
  customElements.define('rv-faq-list', RvFaqList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-trustpilot-carousel"] && !Shopify.designMode) return;
  try {
    
  class RvTpCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rv-tp__track');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      this.prevBtn.addEventListener('click', () => this.scroll(-1));
      this.nextBtn.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.updateButtons());
      this.updateButtons();
    }

    scroll(dir) {
      const card = this.track.querySelector('.rv-tp__card');
      const cardWidth = card ? card.offsetWidth + 16 : 260;
      this.track.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
    }

    updateButtons() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prevBtn.disabled = scrollLeft <= 0;
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }

  customElements.define('rv-tp-carousel', RvTpCarousel);

  } catch(e) { console.error(e); }
})();
})();
